import { LegalPage } from './LegalPage';

const sections = [
  {
    title: 'What data we collect',
    body: [
      'We only collect the data required to operate the Lighthouse candidate, employer, and admin experiences.',
    ],
    bullets: [
      'Profile and application details that you enter in the product.',
      'Usage signals (feature clicks, search queries) captured via PostHog for product analytics.',
      'Support conversations, lead forms, and billing metadata for employers.',
      'Authentication data from Auth0 such as user id, verified email, and assigned roles.',
    ],
  },
  {
    title: 'How we use your information',
    body: [
      'Lighthouse uses your information to provide the services you request, personalise job and match recommendations, and keep the platform safe.',
    ],
    bullets: [
      'Match candidates and jobs based on structured profile data.',
      'Power saved searches, alerts, interview reminders, and digest emails.',
      'Provide employers with aggregated insights (never exposing hidden fields without your explicit action).',
      'Monitor abuse, enforce moderation rules, and satisfy legal obligations.',
    ],
  },
  {
    title: 'When we share information',
    body: [
      'We do not sell personal information. Data is only shared with processors required to run the service (Auth0, Cloudflare, Neon, Stripe, Resend, PostHog, Lighthouse Monitor) under data processing agreements.',
      'If you apply to a job or send a message, the receiving employer sees the data you submitted for that specific action.',
    ],
  },
  {
    title: 'Your controls',
    body: [
      'You can review, edit, or delete profile data inside the candidate or employer settings area. Requests for data export or permanent deletion can also be initiated through the settings area or by contacting the support team.',
      'Email preferences (alerts, digests, employer outreach) can be updated in Notification Settings at any time.',
    ],
  },
  {
    title: 'Data retention & security',
    body: [
      'Candidate resumes, transcripts, and other uploads are stored in encrypted Cloudflare R2 buckets. Access is logged and time-limited.',
      'We retain candidate data for 18 months after the last activity, unless you refresh consent or request deletion sooner.',
    ],
  },
];

export function PrivacyPolicyPage() {
  return (
    <LegalPage
      title="Privacy Policy"
      description="How Lighthouse Jobs collects, processes, and protects personal data for candidates, employers, and admins."
      lastUpdated="14 November 2025"
      path="/privacy"
      sections={sections}
    />
  );
}
